import AnamnesisPhasePage from '../../../components/registry/AnamnesisPhasePage';
import type { PhasePageProps } from '../../../components/registry/RegistryPhaseWorkspace';
import dermatoApi from '../../../api/dermatoApi';

/** Faza 1 — Conștientizare & Anamneză: chestionarul importat + exporturile PDF. */
export default function Faza1Page({ record, patient, status }: PhasePageProps) {
  return (
    <AnamnesisPhasePage
      title="Faza 1 — Conștientizare & Anamneză"
      program="dermato"
      record={record}
      patient={patient}
      status={status}
      downloaders={{
        anamnesis: (formId) => dermatoApi.downloadAnamnesisPdf(formId),
        full: (formId) => dermatoApi.downloadFullPdf(formId),
      }}
    />
  );
}
